class ZoomGallery extends HTMLElement {
  constructor() {
    super();

    this.zoomClose = this.querySelector('.js-close-zoom');
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    window.addEventListener('zoomGalleryShow', () => {
      this.classList.add('is-visible');
      document.body.classList.add('zoom-gallery-overflow');
    });

    this.zoomClose.addEventListener('click', () => {
      this.classList.remove('is-visible');
      document.body.classList.remove('zoom-gallery-overflow');
    });
  }
}

customElements.define('zoom-gallery', ZoomGallery);
